/** Mailgun list — Angular `{{ mail.sent_at | date : 'MM/dd/yyyy hh:mm:ss a' }}`. */
export const MAILGUN_LOG_DATE_PATTERN = 'MM/dd/yyyy hh:mm:ss a'

/** Mailtrap / IMAP lists — Angular `{{ … | date : 'yyyy-MM-dd hh:mm:ss a' }}`. */
export const MAIL_LOG_DATE_PATTERN = 'yyyy-MM-dd hh:mm:ss a'

export const DATE_ONLY_PATTERN = /^(\d{4})-(\d{1,2})-(\d{1,2})$/

export const UNIX_SECONDS_TO_MS = 1000

export const EMPTY_DATE_PLACEHOLDER = '—'
